import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d421a26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-document-preview" }
const _hoisted_2 = {
  key: 0,
  class: "card-body",
  style: {"display":"grid","grid-template-rows":"auto 1fr","height":"100%"}
}
const _hoisted_3 = {
  class: "bg-light row d-flex justify-content-between align-items-center w-100 p-3",
  style: {"top":"0"}
}
const _hoisted_4 = {
  class: "d-flex align-items-center justify-content-between",
  style: {"gap":"10px"}
}
const _hoisted_5 = { class: "flex flex-center" }
const _hoisted_6 = { style: {"overflow":"hidden"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "card-body d-flex justify-content-center align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons tw-document-icon" }, "description", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.templateSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              (_ctx.previewImages.length > 0)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "btn btn-outline-primary",
                    icon: "download",
                    loading: _ctx.isDownloading,
                    onClick: _ctx.onDownloadEvent
                  }, {
                    loading: _withCtx(() => [
                      _createVNode(_component_q_spinner_facebook)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("task.buttons.download_document")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    class: "btn btn-outline-primary",
                    icon: "arrow_back_ios",
                    onClick: _ctx._previousPage
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(this.currentPreviewIndex + 1), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    class: "btn btn-outline-primary",
                    icon: "arrow_forward_ios",
                    onClick: _ctx._nextPage
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.previewImages.length > 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.previewImages[_ctx.currentPreviewIndex],
                  style: {"width":"100%","height":"100%"}
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.templateSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}